import React, { memo, useEffect, useState } from "react";
import { connect } from "react-redux";
import s from "./index.module.less";
import { getUserCouponList, getUserTops } from "@/api/index";
import { LlwMemberLocationClick } from '@/utils/sensorsFunc';

const CouponModal = (props) => {
  const { setVipRechargeModalVisible, setMemberLocation, updateCouponModalVisible, userInfo, updateUserInfo } = props;
  const [couponInfo, setCouponInfo] = useState({}); // 优惠券信息

  useEffect(() => {
    getUserCouponList({
      price: 16,
      cz_channel: 27
    }).then(res => {
      setCouponInfo(res.data && res.data.length ? res.data[0] : {});
    })
  }, []);
  
  const closeCouponModal = () => {
    updateCouponModalVisible(false);
    updateUserInfo({
      ...userInfo,
      first_discount: true
    });
  };

  const toUseCoupon = () => {
    closeCouponModal();
    setVipRechargeModalVisible(true);
    // 埋点
    setMemberLocation(25);
    getUserTops().then(res => {
      LlwMemberLocationClick({
        is_recharge_xzb: res.data.is_recharge_xzb
      });
    });
  };

  return (
    <div className={s.couponModalWrap}>
      <div className={s.couponModalInner}>
        <div
          className={s.couponModalClose}
          onClick={() => closeCouponModal()}
        ></div>
        <div className={s.couponModalContent}>
          <div className={s.couponCard}>
            <div className={s.couponCardLeft}>
              <div className={s.couponMoney}><span>￥</span>{couponInfo.coupon_price}</div>
              <div className={s.couponDesc}>满{couponInfo.use_limit_price}元可用</div>
            </div>
            <div className={s.couponCardRight}>
              <div className={s.couponName}>{couponInfo.coupon_title}</div>
              <div className={s.couponText}>{couponInfo.coupon_end_time}</div>
            </div>
          </div>
          <div
            className={s.couponModalButton}
            onClick={() => toUseCoupon()}
          ></div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({app}) => {
  return {
    userInfo: app.userInfo,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setVipRechargeModalVisible: (params) => {
      return dispatch({
        type: "app/setVipRechargeModalVisible",
        payload: params,
      });
    },
    setMemberLocation: (params) => {
      return dispatch({
        type: "app/setMemberLocation",
        payload: params
      });
    },
    updateCouponModalVisible: (params) => {
      return dispatch({
        type: "app/updateCouponModalVisible",
        payload: params,
      })
    },
    updateUserInfo: (params) => {
      return dispatch({
        type: "app/setUserInfo",
        payload: params
      });
    }
  };
};

export default memo(connect(mapStateToProps, mapDispatchToProps)(CouponModal));
